export const routes = {
    organisation: {
        dashboard: "/organisation/dashboard",
        login: "/organisation/login",
        forgotPassword: "/organisation/forgot-password",
        challengeEdit: "/organisation/challenges/update/:id",
        challengeInfo: "/organisation/challenges/info/:id",
        challengeCreate: "/organisation/challenges/create",
        challengeCreateForAnotherOrganisation: "/organisation/challenges/create-for-another-organisation",
        challengeInterOrganisationGuide: "/organisation/challenges/inter-organisation-guide",
        challengeMobilityDuel: "/organisation/challenges/duel/:id",
        challengeDashboard: "/organisation/challenges/dashboard",
        challengeList: "/organisation/challenges",
        profile: "/organisation/profile",
        branch: "/organisation/branches",
        notification: "/organisation/notifications",
        email: "/organisation/emails",
        branchDetails: "/organisation/branches/:id",
        notificationDetails: "/organisation/notifications/:id",
        emailDetails: "/organisation/emails/:id",
        FAQ: "/organisation/FAQ",
        users: "/organisation/users/:userID",
        settings: "/organisation/settings",
        carpoolEvents: "/organisation/carpool-events",
        carpoolEvent: "/organisation/carpool-events/:id",
        zones: "/organisation/zones",
        heatMap: "/organisation/heat-map",
    },
    city: {
        dashboard: "/city/dashboard",
        login: "/city/login",
        profile: "/city/profile",
        postalCodeMap: "/city/postalCodeMap",
        branch: "/city/branches",
        category: "/city/categories",
        challengeEdit: "/city/challenges/update/:id",
        challengeInfo: "/city/challenges/info/:id",
        challengeCreate: "/city/challenges/create",
        challengeDashboard: "/city/challenges/dashboard",
        notification: "/city/notifications",
        badge: "/city/badges",
        challengeRecommendationRules: "/city/challenge-recommendation-rules",
        news: "/city/news",
        happyHours: "/city/happy_hours",
        newsDetails: "/city/news/:id",
        email: "/city/emails",
        mailerLite: "/city/mailerlite",
        notificationDetails: "/city/notifications/:id",
        emailDetails: "/city/emails/:id",
        challengeList: "/city/challenges",
        FAQ: "/city/FAQ",
        KBS: "/city/KBS",
        manage: "/city/manage",
        settings: "/city/settings",
        integrationChecklist: "/city/integration-checklist",
        maps: "/city/maps",
        heatMap: "/city/heat-map",
        heatMapLegacy: "/city/heat-map-legacy",
        reports: "/city/reports",
        mobileReports: "/city/mobile-reports",
        categoryDetails: "/city/categories/:id",
        branchDetails: "/city/branches/:id",
        users: "/city/users/:userID",
        organisations: "/city/organisations/:organisationId",
        allUsers: "/city/users",
        allUsersSessions: "/city/users-sessions",
        allOrganisations: "/city/organisations",
        carpoolEvents: "/city/carpool-events",
        carpoolEvent: "/city/carpool-events/:id",
        socialDashboard: "/city/social-dashboard",
    },
    tenant: {
        login: "/tenant/login",
        dashboard: "/tenant/dashboard",
        stores: "/tenant/dashboard/stores",
        addProfile: "/tenant/profile-add",
        profile: "/tenant/profile",
        profileById: "/tenant/profile/:id",
        orders: "/tenant/dashboard/orders",
        productList: "/tenant/dashboard/products",
        tenantKBS: "/tenant/tenantKBS",
        productForAction: "/tenant/dashboard/products/:typeOfAction",
        productBarCodes: "/tenant/dashboard/products/edit/:productId/barCodes",
    },
    register: {
        entity: "/register/:entity",
    },
    dynamicLink: {
        entity: "/partage",
    },
};

export const addTenantProductRoute = routes.tenant.productForAction.replace(':typeOfAction', 'add');
export const editTenantProductRoute = routes.tenant.productForAction.replace(':typeOfAction', 'edit');
